import React from 'react';
import { Flex } from 'antd';

import { useTheme } from '../../../../../hooks/useTheme';
import { useSetting } from '../hooks/useSetting';
import * as S from '../styles/Setting.style';
import { SettingCardProps } from '../service/setting.interface';

export const SettingCard = ({
    title,
    icon,
    link,
}: Pick<SettingCardProps, 'title' | 'icon' | 'link'>) => {
    const { colorPrimaryBgHover, colorPrimary } = useTheme();
    const { viewSetting } = useSetting();

    const Icon = icon;

    return (
        <S.Card
            role='button'
            onClick={() => viewSetting(link)}
            $hoverBg={colorPrimaryBgHover}
        >
            <Flex justify={'center'}>
                <Icon />
            </Flex>
            <S.Title $color={colorPrimary}>{title}</S.Title>
        </S.Card>
    );
};
